import React, { useState, useEffect } from 'react'
import sha256 from 'js-sha256'
import axios from 'axios'
import NotesItem from '../components/notesItem'
import { useNavigate } from 'react-router-dom';
import {format} from 'date-fns'
import LoadingSpinner from './Spinner'
import OverlayLoader from '../modalPopups/overlayLoader'

export default function NotesSection(props) {

    const navigate = useNavigate();


    const apiAddNotesUrl = `${process.env.REACT_APP_CSAPI_BASE_URL}/agent/create-note`;
    const apiGetNotesUrl = `${process.env.REACT_APP_CSAPI_BASE_URL}/agent/show-notes`;

    const hash = sha256(props.searchterm);
	const accessToken = localStorage.getItem("accessToken");

    let AddNotesUrl = `${apiAddNotesUrl}?hash=${hash}`;
    let AddShowNotesUrl = `${apiGetNotesUrl}?hash=${hash}`;

    const [note, setNote] = useState({reason: "", comment: ""});
    const [errorvalid, seterrorvalid] = useState(false);
    const [addNoteResultStatus, setaddNoteResultStatus] = useState('');
    const [notesData, setNotesData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [overLayPopupShow, setOverLayPopupShow] = useState(false);
    const [overLayPopupText, setOverLayPopupText] = useState('');


    const reasons = [
		{ label: "Please Select", value: '' },
        { label: "Customer Saved", value: 'Customer Saved' },
		{ label: "Account Cancelled", value: 'Account Cancelled' },
        { label: "50% Refund", value: '50% Refund' },
        { label: "100% Refund", value: '100% Refund' },
        { label: "2 Months Refund", value: '2 Months Refund' },
        { label: "Refund all Months", value: 'Refund all Months' },
        { label: "Refunded all Products", value: 'Refunded all Products' },
        { label: "Charge Back Threat", value: 'Charge Back Threat' },
        { label: "Other", value: 'Other' }
	];

    const handleOverylayModalShowClose = (modalStatus,modalText) => {
        setOverLayPopupShow(modalStatus);
        setOverLayPopupText(modalText)
    }


    const reasonsList = reasons.length > 0
		&& reasons.map((item, i) => {
		return (
			<option key={i} value={item.value}>{item.label}</option>
		)
	}, this);


    


    const handleAddNotes = (e)=>{
        e.preventDefault();

        if(note.reason !== "" && note.comment !== "")
        {
            seterrorvalid(false);

            
            axios.post(AddNotesUrl, note, {				
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                },
            })
            .then(result => {
                //console.log("result="+result.status);
                //console.log("result1="+result.data.status);
                if(result.data.status === 'success')
                {
                    setaddNoteResultStatus("Note Has Been Added Successfully");
                    setNote({reason: "", comment: ""})
                    setTimeout(() => {
                        setaddNoteResultStatus();
                        setIsLoading(true);
		                GetCustomerNotes(AddShowNotesUrl);// eslint-disable-next-line
                    }, 3000);
                }
            })
            .catch((error) => {
                // Error
                if(error.response.status === 401)
                {
                    localStorage.clear();
                    navigate("/login");
                }
            });
        }
        else
        {
            seterrorvalid(true);
        }
    }

    const onChange = (e)=>{
        setNote({...note, [e.target.name]: e.target.value})
        seterrorvalid(false);
    }

    // Get Notes
    const GetCustomerNotes = (URl) => {
		axios.get(URl, {
			headers: {
				'Authorization': `Bearer ${accessToken}`
			},
		})
		.then(result => {
            setIsLoading(false);
            handleOverylayModalShowClose(false,'')
			if(result.data.status === 'success')
			{
                setNotesData(result.data.data);                
			}
		})
        .catch(error => {
            handleOverylayModalShowClose(false,'')
            if(error.response.status === 401)
			{
				localStorage.clear();
      			navigate("/login");
			}
        })
	}

    useEffect(() => {
        setIsLoading(true);
        handleOverylayModalShowClose(true,'Notes Data Loading... Please Wait')
		GetCustomerNotes(AddShowNotesUrl);// eslint-disable-next-line        
	}, [props.getDate]);

  return (
    <>
        <div className="app-wrapper">
          <div className="app-content pt-3 p-md-3 p-lg-4 ">
              <div className="container-xl">

                <OverlayLoader
                    show={overLayPopupShow}
                    title=''
                    body={overLayPopupText}
                />
                <div className="app-content pt-3 mb-5">
                    {props.searchterm ? (
                        <h3>
                        Search: <code>{props.searchterm}</code>
                        </h3>
                    ) : (
                        <h3>There is no name in the query string</h3>
                    )}
                </div>

                  <h1 className="app-page-title mb-0">Notes</h1>
                  <hr className="mb-4" />
                                
                {errorvalid &&
                    <div className="col-md-7 alert alert-danger alert-dismissible fade show" role="alert">
                        Please Fill the Details
                    </div>
                }
                {addNoteResultStatus &&
                    <div className="col-md-7 alert alert-success alert-dismissible fade show" role="alert">
                        {addNoteResultStatus}
                    </div>
                }
                <div className="d-flex align-items-center justify-content-center">

                <div className="col-md-7 border border-primary border-2 px-4 text-primary shadow-sm mb-4 text-left" style={{borderRadius: "15px"}}>
                <form className="my-3 text-left">
                    <div className="mb-3">
                        <label htmlFor="title" className="form-label">Reason</label>                        

                        <select className="form-control" id="reason" name="reason" value={note.reason} onChange={onChange} required>
                            {reasonsList}
                        </select>
                    </div>
                    <div className="form-group purple-border mb-3">
                        <label htmlFor="comment" className="form-label">Comments</label>
                        <textarea className="form-control" id="comment" name="comment" cols="3" required placeholder="Enter comments..."
                            value={note.comment} 
                            onChange={onChange} 
                            minLength={5}
                        />
                    </div>                   
                
                    <button disabled={note.comment.length<5} type="submit" className="btn btn-primary" onClick={handleAddNotes}>Add Note</button>
                </form>
                </div>

                </div>

                <hr className="mb-4" />
                
                    <h3 className="app-page-title mb-0">All Notes</h3>
                    
                    <div className="row">
                    {isLoading ? <LoadingSpinner loadingText='Fetching Notes...' /> : ''}
                    {notesData.map((element, i)=>{
                        let formattedNotesDate = format(new Date(element.createdDate),"MMM dd, y hh:mm:ss");
                        let agentName = (element.agentInfo === null ? 'No Agent' : element.agentInfo.agentName);
                        return <div className='col-md-3 mb-5' key={i}>
                                    <NotesItem notesreason={element.reason} notesdescription={element.comment} notesdate={formattedNotesDate} notesAgent={agentName} />                            
                                </div>
                    })}

                    {notesData.length === 0 && !isLoading && (
                        <div className="alert alert-danger fade show mt-3">
                            Customer Notes Not Available
                        </div>
                    )}
                    </div>
              </div>
          </div>
      </div>
    </>
    )
}